module.exports = __webpack_public_path__ + "nativec.d91954.svg";